import template from './login.html';
import controller from './auth.controller';

let loginComponent = {
  restrict: 'E',
  bindings: {
  },
  template,
  controller
};

export default loginComponent;


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/common/auth/auth.component.js
 **/